/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Dayjs is a lightweight JavaScript library for parsing, validating, manipulating, and displaying dates and times.
 * @see https://day.js.org/docs/en/installation/
 */
import dateParser from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import isBetween from 'dayjs/plugin/isBetween';

dateParser.extend(timezone);
dateParser.extend(utc);
dateParser.extend(relativeTime);
dateParser.extend(isBetween);

export default dateParser;
